<template>
  <!--
          作者 luoyiming
          时间：2020-06-09
          描述：健康证列表管理
      -->
  <div class="user">
    <!---->
    <div class="common-level-rail"></div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <!-- <el-table-column prop="realname" label="姓名"></el-table-column> -->
          <el-table-column prop="user.mobile" label="手机号" width="200"></el-table-column>
          <el-table-column prop="user.avatarUrl" label="头像" width="200">
            <template slot-scope="scope">
              <img :src="scope.row.user.avatarUrl" width="60px" height="40px" />
            </template>
          </el-table-column>
          <el-table-column prop="certificate" label="健康证/证明材料" width="200">
            <template slot-scope="scope">
              <el-image :src="scope.row.certificate" alt="" :preview-src-list="[scope.row.certificate]" width="60px">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="是否解决">
            <template slot-scope="scope">
              <div>{{ scope.row.status == 1 ? "已解决" : "未解决" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="reject_reason" label="审核原因" width="400"></el-table-column>
          <el-table-column prop="createTime" label="创建日期" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <!-- -->
              <el-button @click="editClick(scope.row)" type="primary" size="small" :disabled="scope.row.status == 1">审核</el-button>

              <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import Edit from "./Edit.vue";
import Add from "./Add.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Edit,
    Add
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [
        {
          id: 3,
          user_id: 8,
          realname: "张鹏",
          gender: 1,
          idnumber: "320639200000112580",
          z_image: "25",
          f_image: "26",
          remark: "",
          createTime: "2023-09-04 17:50:33",
          update_time: "2023-09-04 17:51:04",
          status: 1,
          appId: "10001",
          user: {
            user_id: 8,
            open_id: "omoQq5GAq9AMFB1zu9EZVN1FIHDs",
            mpopen_id: "",
            appopen_id: "",
            union_id: "",
            app_user: "",
            reg_source: "wx",
            nickName: "按时吃饭",
            mobile: "18143461190",
            password: "",
            avatarUrl:
              "https://kafeidian.rchz.top/uploads/20230814/271da122b9674feae5fb235638e7141a.jpg",
            gender: 1,
            country: "",
            province: "",
            city: "",
            address_id: 1,
            balance: "0.00",
            points: 5,
            pay_money: "0.00",
            expend_money: "0.00",
            grade_id: 1,
            referee_id: 0,
            total_points: 5,
            total_invite: 0,
            freeze_money: "0.00",
            cash_money: "0.00",
            user_type: 1,
            gift_money: 0,
            is_delete: 0,
            appId: 10001,
            createTime: "2023-08-14 17:16:49",
            update_time: "2023-08-22 14:46:39",
            is_real: 1,
            member_time: 1699157160,
            card_id: 1,
            is_open_member: 1
          },
          fimage: {
            fileId: 26,
            storage: "local",
            groupId: 0,
            file_url: "",
            save_name: "20230814/c1f7d6f2bf573a4f7313eda140ae7df1.jpg",
            file_name: "20230814174957afb0f2119.jpg",
            file_size: 59294,
            fileType: "image",
            real_name:
              "tmp_7ea61b20c854d801c58a5e40440260f22197ea8947e01bd2.jpg",
            extension: "jpg",
            is_user: 1,
            is_recycle: 0,
            shopSupplierId: 0,
            is_delete: 0,
            appId: 10001,
            createTime: "2023-08-14 17:49:57",
            update_time: 0,
            filePath:
              "https://kafeidian.rchz.top/uploads/20230814/c1f7d6f2bf573a4f7313eda140ae7df1.jpg"
          },
          zimage: {
            fileId: 25,
            storage: "local",
            groupId: 0,
            file_url: "",
            save_name: "20230814/416102f4e9829452a72a1c845252bdd3.jpg",
            file_name: "202308141749525b17f8591.jpg",
            file_size: 20558,
            fileType: "image",
            real_name:
              "tmp_ec73a5850fc45ea040c78962efd8d7f01b302ef91e7c7ed8.jpg",
            extension: "jpg",
            is_user: 1,
            is_recycle: 0,
            shopSupplierId: 0,
            is_delete: 0,
            appId: 10001,
            createTime: "2023-08-14 17:49:52",
            update_time: 0,
            filePath: require("@/assets/img_new/jiankang.png")
            // "https:\/\/kafeidian.rchz.top\/uploads\/20230814\/416102f4e9829452a72a1c845252bdd3.jpg"
          }
        },
        {
          id: 2,
          user_id: 1,
          realname: "李乐彤",
          gender: 1,
          idnumber: "213213213213",
          z_image: "1",
          f_image: "2",
          remark: "",
          createTime: "2023-07-17 16:50:00",
          update_time: "2023-07-17 16:50:00",
          status: 0,
          appId: "10001",
          user: {
            user_id: 1,
            open_id: "omoQq5H8kM-nNHw_b1Bi3EUhkjaA",
            mpopen_id: "",
            appopen_id: "",
            union_id: "",
            app_user: "",
            reg_source: "wx",
            nickName: "omoQq5H8",
            mobile: "15738645563",
            password: "",
            avatarUrl:
              "https://kafeidian.rchz.top/uploads/20230815/fef547ef784e3ea8c5106b6d1da66c7d.jpg",
            gender: 0,
            country: "",
            province: "",
            city: "",
            address_id: 0,
            balance: "1.00",
            points: 0,
            pay_money: "0.00",
            expend_money: "0.00",
            grade_id: 1,
            referee_id: 0,
            total_points: 0,
            total_invite: 0,
            freeze_money: "0.00",
            cash_money: "0.00",
            user_type: 1,
            gift_money: 0,
            is_delete: 0,
            appId: 10001,
            createTime: "2023-07-12 18:19:20",
            update_time: "2023-08-16 11:24:41",
            is_real: 1,
            member_time: 1699157160,
            card_id: 1,
            is_open_member: 1
          },
          fimage: {
            fileId: 2,
            storage: "local",
            groupId: 1,
            file_url: "",
            save_name: "20230714/5645d26948f72f48f91bbba1bd3b5860.png",
            file_name: "20230714105429724897242.png",
            file_size: 17738,
            fileType: "image",
            real_name: "Frame 427319449@2x.png",
            extension: "png",
            is_user: 0,
            is_recycle: 0,
            shopSupplierId: 0,
            is_delete: 1,
            appId: 10001,
            createTime: "2023-07-14 10:54:29",
            update_time: 0,
            filePath:
              "https://kafeidian.rchz.top/uploads/20230714/5645d26948f72f48f91bbba1bd3b5860.png"
          },
          zimage: {
            fileId: 1,
            storage: "local",
            groupId: 1,
            file_url: "",
            save_name: "20230714/5645d26948f72f48f91bbba1bd3b5860.png",
            file_name: "20230714105429f0d2c4392.png",
            file_size: 25480,
            fileType: "image",
            real_name: "Frame 427319450@2x.png",
            extension: "png",
            is_user: 0,
            is_recycle: 0,
            shopSupplierId: 0,
            is_delete: 1,
            appId: 10001,
            createTime: "2023-07-14 10:54:29",
            update_time: 0,
            filePath:
              //  "https:\/\/kafeidian.rchz.top\/uploads\/20230714\/5645d26948f72f48f91bbba1bd3b5860.png"
              require("@/assets/img_new/jiankang.png")
          }
        }
      ],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: "",
        region: ""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*换行*/
    keepTextStyle(val) {
      let str = val.replace(/(\\r\\n)/g, "<br/>");
      return str;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.status = "";

      Params.pageSize = self.pageSize;
      Technician.NoCrimeList(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code != 1) return;
          console.log("===========", data);
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },

    /*删除用户*/

    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Technician.NoCrimeDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getTableList();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/nocrime/part/list.vue